var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E0D1FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12 4C8.68 4 9.18 4.084 9.62 4.252C10.06 4.412 10.404 4.652 10.652 4.972C10.908 5.292 11.036 5.684 11.036 6.148C11.036 6.636 10.932 7.036 10.724 7.348C10.524 7.66 10.252 7.9 9.908 8.068C9.564 8.228 9.184 8.328 8.768 8.368L8.684 9.496H7.184L7.196 7.684C7.948 7.604 8.48 7.456 8.792 7.24C9.112 7.024 9.272 6.732 9.272 6.364C9.272 6.06 9.168 5.82 8.96 5.644C8.752 5.468 8.436 5.38 8.012 5.38C7.596 5.38 7.26 5.5 7.004 5.74C6.756 5.972 6.608 6.304 6.56 6.736L5 6.136C5.136 5.512 5.46 5 5.972 4.6C6.484 4.2 7.2 4 8.12 4ZM7.952 10.276C8.272 10.276 8.524 10.36 8.708 10.528C8.892 10.696 8.984 10.924 8.984 11.212C8.984 11.5 8.892 11.728 8.708 11.896C8.524 12.064 8.272 12.148 7.952 12.148C7.64 12.148 7.392 12.064 7.208 11.896C7.024 11.728 6.932 11.5 6.932 11.212C6.932 10.924 7.024 10.696 7.208 10.528C7.392 10.36 7.64 10.276 7.952 10.276Z",
    fill: "#8052D0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionBadge);
export default __webpack_public_path__ + "static/media/question-badge.952db533.svg";
export { ForwardRef as ReactComponent };